import { get, post, put, patch } from "../Config"

export function GetTagSetting() {
  return get({ url: `/v1/admin/tag-settings` })
}

export function UpdateTagSettings({ params = {}, data = {} }) {
  return put({ url: `/v1/admin/tag-settings`, params, data })
}
